module.exports = "query currentUserQuery {\n  currentUser {\n    id\n    calltoolsAgentId\n  }\n}\n"